/** Les briques partagees entre les ecrans. */
export const composants = {
  champ: {
    masquer: 'Masquer le mot de passe',
    afficher: 'Afficher le mot de passe',
    effacer: 'Effacer la recherche',
  },
  badge: {
    officiel: 'Compte officiel de Sirocco',
    verifie: 'Compte vérifié',
  },
  bulleAppel: {
    revenir: (nom: string) => `Revenir à l’appel avec ${nom}`,
  },
  etat: {
    annule: 'Annulé faute de participants',
    confirme: 'Confirmé',
    spontanee: 'Spontanée',
    enLigne: 'En ligne',
    seuil: (n: number) => `(${n} au min.)`,
  },
  vocal: {
    pause: 'Mettre en pause',
    ecouter: 'Écouter le message vocal',
    apercu: (duree: string) => `Message vocal, ${duree}`,
  },
  onglets: {
    messages: 'Messages',
    evenements: 'Événements',
    feed: 'Feed',
    lieux: 'Lieux',
    profil: 'Profil',
    annuaire: 'Annuaire',
  },
  barre: {
    navigation: 'Navigation principale',
    aRegarder: (onglet: string, n: number) => `${onglet} · ${n} à regarder`,
  },
  photo: {
    pasOuverte: "Cette image n'a pas pu être ouverte",
    pasPreparee: "Cette photo n'a pas pu être préparée",
    recadrer: 'Recadrer la photo',
    annuler: 'Annuler',
    choisir: 'Choisir',
  },
  fichier: {
    pasAjoute: "Ce fichier n'a pas pu être ajouté",
  },
  scanner: {
    sansCamera: "Sirocco n'a pas accès à la caméra. Tu peux cocher les présences à la main.",
  },
  partage: {
    pasParti: "Le partage n'est pas parti.",
    lienCopie: 'Lien copié.',
    impossible: 'Partage impossible depuis ce navigateur.',
    copieImpossible: 'Copie impossible depuis ce navigateur.',
    titre: 'Partager',
    chercher: 'Chercher un ami ou un groupe',
    unInstant: 'Un instant…',
    sansCible: 'Ajoute des amis ou crée un groupe pour partager sans quitter Sirocco.',
    aucun: 'Aucun nom ne correspond.',
    envoi: 'Envoi…',
    ailleurs: 'Partager ailleurs',
    copier: 'Copier le lien',
    envoyeA: (nom: string) => `Envoyé à ${nom}.`,
  },
  image: {
    pasUneImage: "Ce fichier n'est pas une image",
    navigateur: 'Ton navigateur ne sait pas préparer cette image',
    tropLourde: 'Cette image est trop lourde, essaie-en une autre',
    pasOuverte: "Cette image n'a pas pu être ouverte",
  },
  video: {
    tropLourde: (mo: number) =>
    `Cette vidéo est trop lourde : ${mo} Mo, pour 25 au maximum. Filme-la en qualité normale plutôt qu’en 4K.`,
    tropLongue: (secondes: number) => `Quinze secondes au maximum. Celle-ci en fait ${secondes}.`,
  },
  voix: {
    appareil: 'Ton appareil ne sait pas enregistrer de message vocal',
    micro: "Sirocco n'a pas accès au micro. Autorise-le dans les réglages.",
    interrompu: "L'enregistrement s'est interrompu",
    tropCourt: 'Trop court. Garde le doigt appuyé un peu plus longtemps.',
    tropLong: 'Message vocal trop long pour être envoyé',
    illisible: 'Enregistrement illisible',
  },
  itineraire: {
    plans: 'Plans',
  },
  billet: {
    monBillet: 'Mon billet',
  },
  emojis: {
    smileys: 'Émojis',
    gestes: 'Gestes',
    coeurs: 'Coeurs',
    animaux: 'Animaux',
    nourriture: 'Nourriture',
    sports: 'Sports',
    voyages: 'Voyages',
    objets: 'Objets',
    symboles: 'Symboles',
  },
};
